import { GUIDE_REFS, type GuideRef } from "./guides-index";

const STOP = new Set([
  "palworld", "guide", "guides", "the", "and", "for", "with", "your", "faq",
  "how", "to", "in", "of", "a", "best", "explained",
]);

function tokens(text: string) {
  return new Set(
    text
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter((word) => word.length > 2 && !STOP.has(word)),
  );
}

/**
 * Related guides scored on shared topic words (title + tag) rather than the tag
 * alone or file order. This keeps internal anchors keyword-matched, so a cluster
 * (e.g. TCG investing) links to its own siblings instead of an arbitrary slice
 * of the library — the signal that makes crawlers read the set as one topic.
 */
export function relatedGuides(
  guide: { slug: string; title: string; tag: string },
  count = 12,
): GuideRef[] {
  const mine = tokens(`${guide.title} ${guide.tag}`);
  return GUIDE_REFS.filter((ref) => ref.slug !== guide.slug)
    .map((ref) => {
      const theirs = tokens(`${ref.title} ${ref.tag}`);
      let shared = 0;
      for (const word of theirs) if (mine.has(word)) shared += 1;
      return { ref, score: shared + (ref.tag === guide.tag ? 1 : 0) };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, count)
    .map((scored) => scored.ref);
}
